import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Template } from "../_types/template";
import { firstValueFrom, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { LoaderService } from "src/app/core/loader/loader.service";
import { TemplatesContractsService } from "./templates-contracts.service";
import { DialogService } from "primeng/dynamicdialog";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { Filter, FilterOperation, OrFilter } from "src/app/core/jsonapi/filter";
import { SelectTemplateComponent } from "../../cases/cases-detail/select-templates/select-template.component";
import { ConfirmationService } from "primeng/api";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";

@Injectable({
    providedIn: 'root',
})
export class TemplatesService extends Service<Template> {
    public override type = 'templates';
    public override url = 'communications/templates';

    constructor(
        _http: HttpClient,
        _loaderService: LoaderService,
        private templatesContractsService:TemplatesContractsService,
        private dialogService: DialogService,
        private confirmationService: ConfirmationService
    ){
        super(_http, _loaderService);
    }
    
    templateTypes() {
        let templateTypes = [
            { label: 'Plantilla de correo', value: 'Email'},
            { label: 'Plantilla de SMS', value: 'SMS' },
            { label: 'Plantilla de Whatsapp', value: 'Whatsapp' },
            { label: 'Plantilla de documentos', value: 'Document' },
            { label: 'Comunicación', value: 'CaseLog' }
        ];
        return templateTypes;
    }
    getDocumentTypes(){
        let documentTypes = [
            { label: 'Parte de visita', value: 'VisitReport'},
            //{ label: 'Solicitud de compra', value: 'PurchaseRequest' },
            { label: 'Pedido de compra', value: 'purchase_order' }, //PurchaseOrder
            { label: 'Presupuesto de operario', value: 'ingoing_budget_worker' }, //BudgetWorker
            { label: 'Presupuesto a compañia', value: 'company_outgoing_budget' }, //BudgetCompany
            { label: 'Presupuesto a afectado', value: 'affected_outgoing_budget' }, //BudgetWorker
            { label: 'Presupuesto a cliente', value: 'outgoing_budget' }, //BudgetCompany
            { label: 'Albaran a compañia', value: 'company_outgoing_delivery_note' }, //DeliveryNoteCompany
            { label: 'Factura a compañia', value: 'company_outgoing_invoice' }, //InvoiceCompany
            { label: 'Factura', value: 'incoming_invoice' }, //Autofacturas. Facturas de operario.
            { label: 'Reportaje fotográfico', value: 'VisitPhotos' },
            { label: 'Liquidaciones de trabajo', value: 'jobs' } ,//Informe con los jobs de un trbajador.
            { label: 'Factura a cliente', value: 'outgoing_invoice' }, //Facturas a clientes
        ];
        return documentTypes;
    }
    getTemplateTypeLabel(value: string) {
        let templateTypes = this.templateTypes();
        let templateType = templateTypes.find(x => x.value == value);
        return templateType?.label;
    }

    public parseHtml(template_id:string, model: any): Observable<object> {
        let url = this.getAPIUrl()+"/" + template_id + '/html';
        let headers = {
            'Content-Type': 'application/vnd.api+json'
          };
        return this.http.post<object>(url, model, { headers: headers });
    }

    public async getTemplateId(code: string, contractId?: string, companyId?: string, transactionId?: string, caseId?: string, caseServiceId?: string): Promise<string | null> {
        return new Promise(async resolve => {
            let params: IParamsCollection = {
                include: ['template'],
            };
            var filters:any = {
                cultureCode:  new Filter(FilterOperation.equals, 'template.documentType', '', code)
            };

            if(companyId!=null) {
                filters.companyId = new OrFilter([
                    new Filter(FilterOperation.equals, 'companyId', '', companyId),
                    new Filter(FilterOperation.equals, 'companyId', '', null, true)
                ]);
            }else{
                filters.companyId = new Filter(FilterOperation.equals, 'companyId', '');
            }
            
            if(contractId!=null){
                filters.contractId = new OrFilter([
                    new Filter(FilterOperation.equals, 'contractId', '', contractId),
                    new Filter(FilterOperation.equals, 'contractId', '', null, true)
                ]);
            }else{
                filters.contractId = new Filter(FilterOperation.equals, 'contractId', '');
            }

            //creamos filtros
            params.filter = FilterBuilder.fromObject(filters).build(); 

            let aux = await firstValueFrom(this.templatesContractsService.all(params));            
            let templates = aux.data.map(m => m.template).filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
            console.log("Templates", templates);
            if(templates.length > 0){
                if(templates[0].documentType == "VisitReport" || templates.length > 1){
                    //Si es un informe de visita lo mostramos para que pueda sacarlo en word
                    let ref = this.dialogService.open(SelectTemplateComponent, {
                    closable: true,
                    modal: true,
                    header: 'Seleccione la plantilla de documento',
                    width: '500px',
                    data: {
                        templates: templates,
                        transactionId: transactionId,
                        caseId: caseId,
                        caseServiceId: caseServiceId
                    }
                    });                        
                    ref.onClose.subscribe((data: any) => {
                        resolve(data);
                    });
                }else{
                    let data:any = { 
                        templateId: templates[0].id ?? null,
                        metadata: null 
                    };
                    resolve(data);
                }
                
            } else if (templates.length == 0) {
                //resolve(null);
                let ref = this.dialogService.open(SelectTemplateComponent, {
                    closable: true,
                    modal: true,
                    header: 'Error al seleccionar plantilla de documento',
                    width: '500px',
                    data: {
                        message: "No existen plantillas de documentos para el tipo de documento requerido.",
                    }
                });                        
                ref.onClose.subscribe((data: any) => {
                    resolve(data);
                });
                
            }
            /*if(templates.length > 1){
                let ref = this.dialogService.open(SelectTemplateComponent, {
                    closable: true,
                    modal: true,
                    header: 'Seleccione la plantilla de documento',
                    width: '500px',
                    data: {
                        templates: templates,
                        transactionId: transactionId,
                        caseId: caseId,
                        caseServiceId: caseServiceId
                    }
                });                        
                ref.onClose.subscribe((data: any) => {
                    resolve(data);
                });
            } else if (templates.length == 0) {
                //resolve(null);
                let ref = this.dialogService.open(SelectTemplateComponent, {
                    closable: true,
                    modal: true,
                    header: 'Error al seleccionar plantilla de documento',
                    width: '500px',
                    data: {
                        message: "No existen plantillas de documentos para el tipo de documento requerido.",
                    }
                });                        
                ref.onClose.subscribe((data: any) => {
                    resolve(data);
                });
                
            } else{
                let data:any = { 
                    templateId: templates[0].id ?? null,
                    metadata: null 
                };
                resolve(data);
            }*/
        }  );  

    }

    public open(url:string, metadata:any){
        this.http.post(url, metadata, { responseType: 'blob' }).subscribe((response: Blob) => {
            const url = window.URL.createObjectURL(response);
            window.open(url, '_blank');
        });
    }

}
